<template>
    <LegendItem description="Dienst met dienstcode D8" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst is niet te wijzigen" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="false"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst wordt opgeslagen" withoutCell>
        <DeploymentMarker
            :deployment="deploymentUpdating"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="false"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst is gekopieerd" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="clipboard"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst met waarschuwing" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="true"
            :editable="true"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst met wens conflict" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="false"
            :wish="wish"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst met beschikbaarheid conflict" v-if="enabledFeatures.includes('3372_Enableunavailabilities')" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="unavailabilities"
        />
    </LegendItem>
    <LegendItem description="Dienst op ander rooster" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="2"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
            :company="{id: 1, name: 'Uitzendbureau', employees: {}, deploymentsWithoutEmployee: {}}"
        />
    </LegendItem>
    <LegendItem description="Dienst van medewerker uit ander rooster" withoutCell>
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :isOtherRoster="true"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
            :company="{id: 1, name: 'Uitzendbureau', employees: {}, deploymentsWithoutEmployee: {}}"
        />
    </LegendItem>
    <LegendItem description="Dienst met opmerking" withoutCell>
        <DeploymentMarker
            :deployment="deploymentWithComment"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
        />
    </LegendItem>
    <LegendItem description="Dienst met aangepaste tijdspecificatie" withoutCell>
        <DeploymentMarker
            :deployment="deploymentSpecified"
            :shift="getShift()"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
        />
    </LegendItem>
    <template v-for="organisationDeploymentStates in deploymentStates">
        <LegendItem
            v-for="(organisationDeploymentState, index) in organisationDeploymentStates"
            :key="'organisationDeploymentState' + index"
            :description="'Dienst (D8) met toestand ' + organisationDeploymentState.caption + (organisationDeploymentState.comment ? ' (' + organisationDeploymentState.comment + ')' : '')"
            withoutCell
        >
            <DeploymentMarker
                :deployment="getDeploymentWithState(organisationDeploymentState.deploymentStateId)"
                :shift="getShift()"
                :horizontalPosition="1"
                :verticalPosition="1"
                :deploymentIndex="1"
                :resource="resource"
                :day="day"
                :rosterId="1"
                :rosterNames="rosterNames"
                :organisationDeploymentStates="getDeploymentStates(organisationDeploymentState)"
                :clipboard="[]"
                :showWarning="false"
                :editable="true"
                :unavailabilities="[]"
            />
        </LegendItem>
    </template>
    <LegendItem
        v-for="colorId in [shiftTemplateColorEnum.Day,shiftTemplateColorEnum.Evening,shiftTemplateColorEnum.Night,shiftTemplateColorEnum.Other]"
        :key="'color-'+colorId"
        :description="shiftTemplateColorDescription[colorId]"
        withoutCell
    >
        <DeploymentMarker
            :deployment="deployment"
            :shift="getShift(shiftTypeNumberEnum.Paraat, colorId)"
            :horizontalPosition="1"
            :verticalPosition="1"
            :deploymentIndex="1"
            :resource="resource"
            :day="day"
            :rosterId="1"
            :rosterNames="rosterNames"
            :organisationDeploymentStates="deploymentStates"
            :clipboard="[]"
            :showWarning="false"
            :editable="true"
            :unavailabilities="[]"
        />
    </LegendItem>
</template>

<script lang="ts">
    import Dates from '@cquential/date-utils';
    import {DeploymentCopyable, RosterDay} from '@/types/types';
    import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
    import {Deployment, DeploymentSpecification, Unavailability, OrganisationDeploymentState, PersonalPlanningWish, Shift, DeploymentState, ShiftTypeNumber, ShiftTemplateColor} from '@cquential/api';
    import DeploymentMarker from '@/components/Planbord/DeploymentMarker.vue';
    import LegendItem from '@/components/modals/Legend/LegendItem.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            DeploymentMarker,
            LegendItem,
        },
    })
    export default class DeploymentLegendItems extends Vue {
        @Prop({required: true}) public deploymentStates!: Record<DeploymentState, OrganisationDeploymentState[]>;
        @Prop({required: true}) public rosterNames!: Record<number, string>;
        @Prop({required: true}) public enabledFeatures!: string[];

        public get shiftTemplateColorEnum(): typeof ShiftTemplateColor {
            return ShiftTemplateColor;
        }

        public get shiftTypeNumberEnum(): typeof ShiftTypeNumber {
            return ShiftTypeNumber;
        }

        private get shiftTemplateColorDescription(): Record<ShiftTemplateColor, string> {
            return {
                [ShiftTemplateColor.Day]: 'Dagdienst',
                [ShiftTemplateColor.Evening]: 'Avonddienst',
                [ShiftTemplateColor.Night]: 'Nachtdienst',
                [ShiftTemplateColor.Other]: 'Overige diensten',
            };
        }

        private get startDate(): Date {
            return Dates.Utils.startOfWeek(Dates.Utils.today());
        }

        private get deploymentSpecifications(): DeploymentSpecification[] {
            return [
                {
                    begin: Dates.Utils.setTimeOnDate(this.startDate, '10:00'),
                    end: Dates.Utils.setTimeOnDate(this.startDate, '16:00'),
                    stateId: 1,
                    typeId: 2,
                    projectId: null,
                    activityId: null,
                    costCenterId: null,
                    leaveKind: null,
                },
            ];
        }

        private get deployment(): Deployment {
            return {
                id: 1,
                date: this.startDate,
                shiftId: 1,
                stateId: 1,
                publicComment: '',
                companyId: null,
                companyEmployeeId: null,
                resourceId: 1,
                specifications: [],
                positionAssignmentSetGroupPositionDeployments: [],
                updating: false,
                specified: false,
            };
        }

        private get deploymentUpdating(): Deployment {
            return {...this.deployment, updating: true};
        }

        private get deploymentSpecified(): Deployment {
            return {...this.deployment, specified: true, specifications: this.deploymentSpecifications};
        }

        private get deploymentWithComment(): Deployment {
            return {...this.deployment, publicComment: 'Opmerking'};
        }

        private get day(): RosterDay {
            return {
                ended: false,
                published: false,
                proposed: false,
                holiday: false,
                dayName: 'Maandag',
                dayAbbreviation: 'ma',
                formattedDateOnly: Dates.Formatter.formatDateWithoutYear(this.startDate),
                formattedForComputers: Dates.Formatter.formatDateComputerFriendly(this.startDate),
                formattedDateIso: Dates.Formatter.formatDateISO(this.startDate),
                weekend: false,
                date: this.startDate,
            };
        }

        private get resource(): ResourceWithKeyedByDateObjects {
            return {
                id: 1,
                employmentId: 1,
                name: 'Legend',
                nameAddendum: null,
                beginDate: Dates.Utils.addDays(this.startDate, -28),
                endDate: Dates.Utils.addDays(this.startDate, 365),
                workingHoursActType: 'Standaard',
                stampDeployedUntil: Dates.Utils.addDays(this.startDate, 112),
                salaryAcceptedUntil: Dates.Utils.addDays(this.startDate, 1),
                contractedTimes: [],
                leavePeriods: [],
                personalStamps: [],
                deployments: {},
                deploymentProposals: {},
                assignedDays: {},
                unavailabilities: {},
                sickPeriods: [],
            };
        }

        private get clipboard(): DeploymentCopyable[] {
            return [
                {
                    offsetLeft: 2,
                    offsetTop: 2,
                    type: 'deployment',
                    object: {
                        id: 1,
                        date: this.startDate,
                        shiftId: 1,
                        stateId: 1,
                        publicComment: '',
                        companyId: null,
                        companyEmployeeId: null,
                        specified: false,
                        resourceId: 1,
                        specifications: [],
                        positionAssignmentSetGroupPositionDeployments: [],
                    },
                },
            ];
        }

        private get wish(): PersonalPlanningWish {
            return {
                doesntWantToWorkBegin: null,
                doesntWantToWorkEnd: null,
                date: this.startDate,
                recursWeekly: false,
                recursOnDay: 1,
                description: 'wens',
                resourceId: 1,
                wantsShiftId1: null,
                wantsShiftId2: null,
                wantsShiftId3: null,
            };
        }

        private get unavailabilities(): Unavailability[] {
            return [
                {
                    resourceId: 1,
                    date: this.startDate,
                    startTime: '12:00',
                    endTime: '19:00',
                    startDateTime: Dates.Utils.setTimeOnDate(this.startDate, '12:00'),
                    endDateTime: Dates.Utils.setTimeOnDate(this.startDate, '19:00'),
                },
            ];
        }

        public getDeploymentStates(state: OrganisationDeploymentState): Record<number, OrganisationDeploymentState> {
            return {[state.deploymentStateId]: state};
        }

        public getDeploymentWithState(stateId: number): Deployment {
            return {
                ...this.deployment,
                stateId: stateId,
            };
        }

        public getShift(type?: ShiftTypeNumber, colorId?: ShiftTemplateColor): Shift {
            return {
                id: 1,
                rosterId: 1,
                beginDate: Dates.Utils.addDays(this.startDate, -100),
                endDate: Dates.Utils.addDays(this.startDate, 100),
                templateId: 1,
                template: {
                    id: 1,
                    typeNumber: type ?? ShiftTypeNumber.Paraat,
                    type: 'Paraat',
                    isLongPresence: false,
                    code: 'D8',
                    colorId: colorId ?? ShiftTemplateColor.Day,
                    legend: 'Dag 9:00-16:30',
                    isDefault: true,
                    andParentTemplateId: null,
                    orParentTemplateId: null,
                    specifications: [
                        {
                            begin: '09:00',
                            end: '16:30',
                            typeId: 2,
                        },
                    ],
                    hasAllStates: true,
                    hasLeaveState: true,
                },
                postalCode: null,
                houseNumber: null,
            };
        }
    }
</script>
